/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextBase64Decode } from "../../funcs/textPostTextBase64Decode.js";
import { PostTextBase64DecodeRequest$zodSchema } from "../../models/posttextbase64decodeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextBase64DecodeRequest$zodSchema,
};

export const tool$textPostTextBase64Decode: ToolDefinition<typeof args> = {
  name: "text-post-text-base64-decode",
  description: `Base64 解码

这是一个简单实用的 Base64 解码工具。

## 功能概述
你提供一个 Base64 编码的字符串，我们帮你解码成原始的 UTF-8 文本。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextBase64Decode(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
